import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { environment } from '@/helpers/Environment';
import EventBus from '@/helpers/EventBus';
import FormInput2 from '@/components/forms/FormInput2.vue';
import ApplyGiftCards from '@/checkout/components/ApplyGiftCards.vue';
import StripePaymentElement from '@/checkout/components/StripePaymentElement.vue';
import { stripeOptions } from '@/checkout/stripe/stripeOptions';
import store from '@/store/store';
import { normalizeThemeOptions } from '@/themeConfig/processing';
@Component({
    name: 'TixPayment',
    components: { FormInput2, ApplyGiftCards, StripePaymentElement },
})
export default class default_1 extends Vue {
    @Prop({ required: true })
    value;
    @Prop({ default: false })
    processing;
    @Prop({ required: true })
    isModifiable;
    @Prop()
    stripe;
    @Prop({ required: true })
    paymentDueByCreditCard;
    @Prop({ default: false })
    hideWalletPayments;
    elements = null;
    // Options plugin properties.
    t;
    mounted() {
        EventBus.$on('theme changed', (params) => {
            if (!params.remountStripe)
                return;
            this.elements?.getElement('payment')?.destroy();
            this.elements = null;
            if (this.stripe) {
                this.$nextTick(() => {
                    const options = this.stripeOptions(params.themeOptions);
                    this.elements = this.stripe.elements(options);
                });
            }
        });
        this.initializeStripeElements(this.stripe);
    }
    get giftCardsEnabled() {
        return this.isModifiable && Boolean(environment.ledgers?.default_giftcard_event);
    }
    @Watch('stripe')
    initializeStripeElements(stripe) {
        if (stripe) {
            const themeOptions = normalizeThemeOptions(environment.theme);
            const options = this.stripeOptions(themeOptions);
            this.elements = stripe.elements(options);
        }
        else {
            this.elements = null;
        }
        this.$emit('elementsInitialized', this.elements);
    }
    // Vue does not observe changes to element styles, so this cannot be a computed property (getter).
    // @see https://v2.vuejs.org/v2/guide/components-edge-cases.html#Accessing-Child-Component-Instances-amp-Child-Elements
    stripeOptions(theme) {
        // Uses the <FormInput2> and it's <input> element as a style guide/source for the Stripe element style.
        // Can't use ref as the input is in the child component.
        const inputElement = this.$refs.input.$el;
        const hoverElement = this.$refs.hover.$el;
        const focusElement = this.$refs.focus.$el;
        const invalidElement = this.$refs.invalid.$el;
        const messageElement = this.$refs.message;
        const styles = {
            input: {
                default: window.getComputedStyle(inputElement.querySelector('input[type=text]')),
                hover: window.getComputedStyle(hoverElement.querySelector('input[type=text]')),
                focus: window.getComputedStyle(focusElement.querySelector('input[type=text]')),
                invalid: window.getComputedStyle(invalidElement.querySelector('input[type=text]')),
            },
            label: window.getComputedStyle(inputElement.querySelector('.label')),
            message: window.getComputedStyle(messageElement),
        };
        return stripeOptions(theme, this.paymentDueByCreditCard, styles, this.pmcId);
    }
    @Watch('pmcId')
    @Watch('paymentDueByCreditCard')
    updateElements() {
        const themeOptions = normalizeThemeOptions(environment.theme);
        this.elements?.update(this.stripeOptions(themeOptions));
    }
    get pmcId() {
        // Only support card for scheduled payments at this stage
        // https://github.com/stqry/tix-web-client/pull/2568#discussion_r1811782905
        if (store.getters['Cart/hasScheduledPayments']) {
            return undefined;
        }
        return store.getters['Cart/stripeFee']?.pmc_id;
    }
}
